<div class="form-row flex-h">
    
        <div [formGroup]="mainForm" class="action-col1" [ngClass]="{'has-error': mainForm.get('name')?.invalid && (mainForm.get('name')?.touched)}">
            <div class="name-col">
                <mat-form-field appearance="outline" class="full-width f-w-500">
                    <mat-label>{{ 'GOAL_ACTION_EDIT.GOAL_SETTING_COMPETENCE_ACTIVITY_NAME' | translate }}</mat-label>
                    <textarea matInput 
                        formControlName="name" 
                        title="{{action.name}}"  
                        autocomplete="off" 
                        rows="4"  
                        required></textarea>
                </mat-form-field>
            </div>
            <div class="deadline-col">
                <mat-form-field appearance="outline" class="full-width input-m">
                    <mat-label>{{ 'GOAL_ACTION_EDIT.DEADLINE' | translate }}</mat-label>
                    <mat-select formControlName="deadline">
                        <mat-option [value]="null">-</mat-option>
                        <mat-option *ngFor="let item of months" [value]="item.id">{{ item.name }}</mat-option>
                    </mat-select>
                </mat-form-field>

                <div class="weight-and-exp">
                    <mat-form-field appearance="outline" class="weight-field custom-purple input-m color-alt3">
                        <mat-label>{{ 'GOAL_ACTION_EDIT.WEIGHTING' | translate }}</mat-label>
                        <input matInput
                            type="text"
                            inputmode="numeric"
                            formControlName="weight"
                            title="Súlyozás érték: üres, vagy 1-100%">
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="min-exp-field input-m color-alt4">
                        <mat-label>{{ 'GOAL_ACTION_EDIT.MIN_EXPECTATION_PERCENT' | translate }}</mat-label>
                        <input matInput
                            type="text"
                            inputmode="decimal"
                            formControlName="minExpectation"
                            title="Minimum elvárás érték: üres vagy 1-100%">
                    </mat-form-field>
                </div>
            </div>
        </div>

        <div class="action-col2">
            <div class="slider-component" *ngFor="let ap of getDisplayProgressList(); let i = index">
                <div class="slider-toggle">
                    <mat-checkbox [(ngModel)]="ap.checkBoxValue" (change)="setSlider(ap)" [disabled]="!allowSliderEdit(ap)"></mat-checkbox>
                </div>
                <div class="slider-container">
                    <div class="slider-labels flex-h">
                        <div class="slider-text-label" [title]="ap.employeeId === currentPeriod.employeeId ? ('GOAL_ACTION_EDIT.SELF_ASSESSMENT' | translate) : ap.employeeName">{{ ap.employeeId === currentPeriod.employeeId ? ('GOAL_ACTION_EDIT.SELF_ASSESSMENT' | translate) : ap.employeeName }}</div>
                        <div class="slider-value-label" [ngClass]="{'below-expectation': ap.progress && mainForm.get('minExpectation').value && ap.progress < mainForm.get('minExpectation').value}">{{ ap.progress !== null && ap.progress != undefined ? ap.progress + '%' : '-' }}</div>
                    </div>
                    <mat-slider [max]="currentPeriod.reviewPeriod.reviewPeriodGoalSettings.sliderMax" [min]="currentPeriod.reviewPeriod.reviewPeriodGoalSettings.sliderMin" [step]="currentPeriod.reviewPeriod.reviewPeriodGoalSettings.sliderStep" [disabled]="!allowSliderEdit(ap) || !isSliderChecked(ap)" #ngSlider>
                        <input matSliderThumb [value]="ap.progress" (input)="ap.progress = {source: ngSliderThumb, parent: ngSlider, value: ngSliderThumb.value}.value" #ngSliderThumb="matSliderThumb" (change)="progressChanged({source: ngSliderThumb, parent: ngSlider, value: ngSliderThumb.value}, ap, action, goal)" />
                    </mat-slider>
                </div>
            </div>
        </div>
        <button mat-icon-button color="primary" class="action-delete hidden-print icon-button" [disabled]="!allowDelete()" (click)="deleteAction(goal, action.id)" title="{{ 'GOAL_ACTION_EDIT.DELETE_ACTIVITY' | translate }}">
            <mat-icon>delete</mat-icon>
        </button>
</div>
<div class="comment-block">
    <div class="comment-title">{{ 'GOAL_ACTION_EDIT.COMMENTS' | translate }}</div>
    <div class="comment-content">
        <div class="comment-section">
            <app-comment-section [config]="createCommentConfig(action)" [comments]="action.comments"
                    [isEditable]="false"
                    [isShowDeleteButton]="false"
                    [isAutoSave]="false"
                    [singleComments]="true"
                    [isCommentHeaderVisible]="true"
                    displayStyle="style-3"
            ></app-comment-section>
        </div>
        <div class="button-group">
            <button mat-flat-button class="lg-button2 sm-text button-bg-alt4" [disabled]="!allowComment()" (click)="showCommentDialog()" title="{{ 'GENERAL.EDIT_COMMENT_TITLE' | translate }}" [innerHTML]="'GENERAL.EDIT_COMMENT' | translate"></button>
        </div>
    </div>
</div>
<div>
    <app-audit-line [data]="action"></app-audit-line>
</div>
